(function () {

    function updateModalState(modalBox, state, message = '') {
        const question = modalBox.querySelector('.seal-modal-question');
        const description = modalBox.querySelector('.seal-modal-description');
        const buttonsWrapper = modalBox.querySelector('.seal-modal-buttons');

        if (state === 'loading') {
            question.innerHTML = `
                <div class="seal-loading-spinner"></div>
                <span>Loading...</span>
            `;
            question.style.display = 'flex';
            question.style.flexDirection = 'column';
            question.style.alignItems = 'center';
            question.style.gap = '10px';
            description.textContent = '';
            buttonsWrapper.style.display = 'none';
        } else if (state === 'result') {
            question.innerHTML = ''; // Clear spinner
            question.textContent = message;
            question.style.display = 'block'; // Reset display
            description.textContent = '';
            buttonsWrapper.innerHTML = '';
            const closeBtn = document.createElement('div');
            closeBtn.className = 'seal-button';
            closeBtn.textContent = 'Close';
            closeBtn.style.padding = '12px 15px !important';
            closeBtn.onclick = () => document.body.removeChild(modalBox.parentElement);
            buttonsWrapper.style.display = 'flex';
            buttonsWrapper.appendChild(closeBtn);
        }
    }

    function createConfirmationBox(onConfirm) {
        // Inject CSS for the loading spinner
        const style = document.createElement('style');
        style.textContent = `
            .seal-loading-spinner {
                border: 4px solid #f3f3f3;
                border-top: 4px solid #dfa93d;
                border-radius: 50%;
                width: 30px;
                height: 30px;
                animation: spin 1s linear infinite;
                display: block;
            }
            @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
            }
        `;
        document.head.appendChild(style);

        // background
        const overlay = document.createElement('div');
        overlay.style.position = 'fixed';
        overlay.style.top = 0;
        overlay.style.left = 0;
        overlay.style.width = '100%';
        overlay.style.height = '100%';
        overlay.style.background = 'rgba(0,0,0,0.2)';
        overlay.style.display = 'flex';
        overlay.style.justifyContent = 'center';
        overlay.style.alignItems = 'center';
        overlay.style.zIndex = '9999';

        // box
        const box = document.createElement('div');
        box.id = 'seal-confirmation-box';
        box.style.background = '#fff';
        box.style.padding = '20px';
        box.style.borderRadius = '8px';
        box.style.maxWidth = '400px';
        box.style.textAlign = 'center';

        const question = document.createElement('div');
        question.className = 'seal-modal-question';
        question.textContent = 'Are you sure you want to skip your next delivery?';
        question.style.fontSize = '18px';
        question.style.fontWeight = 'bold';
        question.style.marginBottom = '12px';

        const description = document.createElement('div');
        description.className = 'seal-modal-description';
        description.textContent = 'Your next scheduled delivery will be skipped, and you won’t be charged for it.';
        description.style.marginBottom = '15px';

        const buttonsWrapper = document.createElement('div');
        buttonsWrapper.className = 'seal-modal-buttons';
        buttonsWrapper.style.display = 'flex';
        buttonsWrapper.style.justifyContent = 'center';
        buttonsWrapper.style.gap = '10px';

        const confirmBtn = document.createElement('div');
        confirmBtn.id = 'seal-confirmation-box-confirm';
        confirmBtn.className = 'seal-button seal-button-red';
        confirmBtn.textContent = 'Skip it';
        confirmBtn.style.padding = '12px 15px !important';
        confirmBtn.onclick = () => {
            updateModalState(box, 'loading');
            onConfirm(box);
        };

        const cancelBtn = document.createElement('div');
        cancelBtn.id = 'seal-confirmation-box-cancel';
        cancelBtn.className = 'seal-button';
        cancelBtn.textContent = 'Wait, I changed my mind!';
        cancelBtn.style.padding = '12px 15px !important';
        cancelBtn.onclick = () => document.body.removeChild(overlay);

        buttonsWrapper.appendChild(confirmBtn);
        buttonsWrapper.appendChild(cancelBtn);

        box.appendChild(question);
        box.appendChild(description);
        box.appendChild(buttonsWrapper);
        overlay.appendChild(box);

        document.body.appendChild(overlay);
    }

    async function skipNextDelivery(modalBox) {
        try {
            const emailElement = document.querySelector('.seal-email-address span[data-hide-on-edit]');
            if (!emailElement) {
                updateModalState(modalBox, 'result', 'Failed: Email not found');
                return;
            }
            const email = emailElement.textContent.trim();

            const response = await fetch('https://seal-extra.vercel.app/api/seal-skip-delivery', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email })
            });

            const data = await response.json();

            if (response.ok && data.success) {
                updateModalState(modalBox, 'result', 'Successfully skipped');
            } else if (!data.success && data.error === 'Next billing cycle is already skipped!') {
                updateModalState(modalBox, 'result', 'Delivery already skipped');
            } else {
                updateModalState(modalBox, 'result', `Not Skipped: ${data.error || 'Request failed'}`);
            }
        } catch (err) {
            console.error('SEAL - Error:', err);
            updateModalState(modalBox, 'result', 'Not Skipped: ' + err.message);
        }
    }

    function injectSkipButton() {
        const pauseButton = document.getElementById('seal-pause-button');
        const section = document.querySelector('.seal-dynamic-sectioned');
        const unsubscribeButton = document.getElementById('seal-unsubscribe-button');

        if (pauseButton && section) {
            pauseButton.style.display = 'none'; // hide original pause

            // Inject CSS to override seal-button margin and padding
            const style = document.createElement('style');
            style.textContent = `
                .seal-button {
                    margin: 0 !important;
                    padding: 12px 15px !important;
                }
            `;
            document.head.appendChild(style);

            // Set padding and transform for seal-unsubscribe-button
            if (unsubscribeButton) {
                unsubscribeButton.style.padding = '0px';
                unsubscribeButton.style.transform = 'translateY(-18px)';
                unsubscribeButton.style.textDecoration = 'underline';
            }

            // style section
            section.style.display = 'flex';
            section.style.flexDirection = 'column';
            section.style.alignItems = 'center';

            const skipButton = document.createElement('div');
            skipButton.textContent = 'SKIP DELIVERY';
            skipButton.className = 'seal-button';
            skipButton.style.background = '#dfa93d';
            skipButton.style.fontWeight = 'bold';
            skipButton.style.color = '#FFFFFF';
            skipButton.style.fontSize = '18px';
            skipButton.style.padding = '12px 15px';
            skipButton.style.marginBottom = '5px';

            skipButton.onclick = () => {
                createConfirmationBox((modalBox) => skipNextDelivery(modalBox));
            };

            const orDivider = document.createElement('div');
            orDivider.textContent = 'OR';
            orDivider.style.fontWeight = 'bold';
            orDivider.style.fontSize = '14px';
            orDivider.style.margin = '2px 0';

            pauseButton.insertAdjacentElement('afterend', skipButton);
            skipButton.insertAdjacentElement('afterend', orDivider);
        }
    }

    function waitForElements() {
        const interval = setInterval(() => {
            const pauseButton = document.getElementById('seal-pause-button');
            const section = document.querySelector('.seal-dynamic-sectioned');
            if (pauseButton && section) {
                clearInterval(interval);
                injectSkipButton();
            }
        }, 200);
    }

    waitForElements();
})();